import { useState } from "react";
import { useLocation } from "react-router-dom";

import { BmsHeader } from "../../components/main-components/app.header";
import { SkewBox } from "../../components/page/skew";
import { AppFooter } from "../../components/main-components/footer";
import { formatUrl } from "../../helpers/parse-url";
import VideoPlayer from "../../components/utilities/video-player";
import { QuestionUnit } from "../../components/tutorials/question-unit";
import classNames from "classnames";

export const LessonDetails = () => {

    const {tutorial} = useLocation()?.state;
    const [answers, setAnswers] =  useState({});
    const [submited, setSubmited] = useState(false);

    const { questions } = tutorial?.evaluation;

    

    const answerArray = Object.values(answers);

    const correctanswers = answerArray.filter((answ, indx) =>{
        return answ === questions[indx].answer;
    }).length;
   

    return (
        <div >
            <BmsHeader />
            <SkewBox title={tutorial?.title} />
            <div className="tutorial-detail">
            <VideoPlayer src={formatUrl(tutorial?.video)} />
            <div className="question-box">
                {submited && (
                    <>
                    <div className="score-box">
                        <span className="score-caption">Score:</span>
                        <span className={classNames("score-val",{"b-av": correctanswers < questions.length /2})}>
                            {correctanswers}/{questions.length}
                        </span>
                    </div>
                    <div className="retake-box">
                        <button className="retake-button" onClick={() => window.location.reload()}>
                            Retake this test
                        </button>
                    </div>
                    </>
                )}
                {questions?.map((quest, indx) => (
                    <QuestionUnit 
                        questionData={quest} 
                        indx={indx}
                        addAnswer={(k) => setAnswers((answ) => ({...answ, [indx ]: k+1})) } 
                        key={indx}
                        isCorrect={parseInt(answers[indx]) === questions[indx].answer}
                        submited={submited}
                    /> 
                ))}
            </div>
            
            <div className="frm-button-box">
                <button 
                    className="frm-button" 
                    onClick={() => setSubmited(true)}
                >
                    Submit
                </button>
            </div>
           
            </div>
            <AppFooter />
        </div>
    );
}